<template>
  <div class="l_model_change_faq">
    <div class="container">
      <div class="content">
        iOS端末をお使いの一部のお客様で、スタンプサポート機能をご利用の際、アプリが落ちてしまう現象が発生しております。
        <br />
        <br />
        お客様にはご迷惑をおかけしておりまして、大変申し訳ありません。
        <br />
        <a @click="tapAction" style="color: #000; font-weight: bold; text-decoration: underline">最新版のアプリ3.3.1へアップデート</a>をお願いいたします。
        <br />
        <br />
        その他、ご不明な点などありましたら、下記よりお問い合わせください。
        <router-link to="/faq/inquiry" @click.native="tapInquiry">
          <div class="l_button__external">
            <UIButton :label="'お問い合わせ'" />
          </div>
        </router-link>
        <p class="caption">
          ※土・日・祝日にいただいたお問合せは翌営業日の受付となります。<br />
          ※メール受信制限等を設定されている場合、返信メールが受け取れない場合がございます。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'

export default {
  name: 'FAQStampSupport',
  components: {
    UIButton
  },
  data: function() {
    return {
      userId: '',
      password: ''
    }
  },
  created() {
    document.title = 'スタンプサポートが使えない'
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', ['actionRequestExternalLink']),
    tapInquiry: function() {
      this.trackEvent(FactoryTrack.createFAQInquiry())
    },
    tapAction() {
      this.trackEvent(FactoryTrack.createAppStore())
      this.actionRequestExternalLink('https://itunes.apple.com/jp/app/id1433877820?mt=8')
    }
  }
}
</script>

<style lang="scss" scoped>
.l_model_change_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;

  p.caption {
    text-align: left;
    margin: 16px -4px;
    font-size: 10px;
    color: rgb(102, 102, 102);
  }
}

.l_model_change_faq h3,
.l_model_change_faq h4 {
  color: #602209;
}

.l_model_change_faq h4 {
  margin: 10px 0px;
}

.l_model_change_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.l_model_change_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}

.l_model_change_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid #efb90f;
}

.l_model_change_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

.l_model_change_faq span.strong {
  font-weight: bold;

  &.red {
    color: #cc0000;
  }
}

.screenshot {
  text-align: center;

  img {
    width: 75%;
    margin: auto 0;
  }
}

p.account-info {
  margin-top: 1em;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: bold;
}

div.border {
  margin: 0;
  padding: 20px 0;
  border-top: 1px solid gray;
  text-align: left;

  &.bottom {
    border-bottom: 1px solid gray;
  }

  .caption {
    display: block;
    font-size: 12px;
    text-align: left;
  }
}

.mail button {
  padding-left: 20px;
  padding-right: 20px;
}

img {
  max-width: 80%;
  width: 188px;
  display: block;
  border: 1px solid #dedede;
  margin: 0 auto;
}

.strong {
  font-weight: bold;
}

.strong-red {
  font-weight: bold;
  color: #e03535;
}
</style>
